<palantir-dialog [title]="title">
  <palantir-dialog-content>
    <palantir-text type="text">{{ text }}</palantir-text>
  </palantir-dialog-content>

  <palantir-dialog-actions [ngClass]="{ 'reverse-button-action': reverseButtons }">
    @if (cancelText) {
      <palantir-button [attr.variant]="cancelVariant" theme="outline" (click)="close()">{{
        cancelText
      }}</palantir-button>
    }
    <palantir-button [attr.variant]="successVariant" (click)="confirm()">{{
      successText
    }}</palantir-button>
  </palantir-dialog-actions>
</palantir-dialog>
